import * as React from "react";
import { useTranslation } from 'react-i18next';

export const useFields = () => {
    const { t } = useTranslation();
    
    return [
        {
            name: "filter1",
            label: t("forms.font_filters_good_condition"),
            type: "checkbox",
            column: 1,
            mandatory: true,
        },
        {
            name: "filter2",
            label: t("forms.font_filters_cleaned"),
            type: "checkbox",
            column: 1,
            mandatory: true,
        }
    ];
};

// Legacy export for backward compatibility
export const fields = (t) => ({
    config: { columns: 1 },
    fields: [
        {
            name: "filter1",
            label: t ? t("forms.font_filters_good_condition") : "Potwierdzono, że filtry są w dobrym stanie technicznym",
            type: "checkbox",
            column: 1,
            mandatory: true,
        },
        {
            name: "filter2",
            label: t ? t("forms.font_filters_cleaned") : "Potwierdzono, że filtry wyczyszczone bądź są czyste (ostatnie czyszczenie nie dłużej niż 30 dni)",
            type: "checkbox",
            column: 1,
            mandatory: true,
        }
    ]
});